module.exports = __webpack_public_path__ + "img/img-business-method-sec-10.png";